module.exports = __webpack_public_path__ + "static/media/piper-nudging-paw-1.743ce3ef.svg";